import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { Store, select } from '@ngrx/store';

import * as fromRoot from '../../../app.reducer';
import { filter, tap, first, switchMap, catchError } from 'rxjs/operators';
import { getDiscountLaddersIDs } from './state/discount-ladders.selectors';
import { DiscountLaddersGetAllAction } from './state/discount-ladders.actions';

@Injectable({
  providedIn: 'root'
})
export class DiscountLaddersGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) { }

  getFromStoreOrAPI(): Observable<any> {
    return this.store
      .pipe(
        select(getDiscountLaddersIDs),
        tap((discountLaddersIDs: any) => {
          if (!discountLaddersIDs) {
            this.store.dispatch(new DiscountLaddersGetAllAction());
          }
        }),
        filter((discountLaddersIDs: any) => discountLaddersIDs),
        first()
      );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.getFromStoreOrAPI()
      .pipe(
        switchMap(() => of(true)),
        catchError(() => of(false))
      );
  }
}
